import { render, staticRenderFns } from "./RevAccount.vue?vue&type=template&id=37bf7a02"
import script from "./RevAccount.vue?vue&type=script&lang=ts"
export * from "./RevAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports